// Func = limiting Scope for this file
;(function () {
	function resizeWindow() {}
	function scrollDown() {
		let top = $(document).scrollTop()
		if (top > 271) {
			$('.sub-menu').addClass('top-submenu')
		} else {
			$('.sub-menu').removeClass('top-submenu')
		}
	}

	function addAdaMapLink(class_name = '', label = 'View ADA MAP', href = '/ada-map', container = 'content') {
		let block_to_insert

		block_to_insert = document.createElement('div')
		block_to_insert.setAttribute('class', 'buttonAdaMap')
		block_to_insert.innerHTML = '<a class="btn btn--blue ' + class_name + '" href="' + href + '">' + label + '</a>'

		document.getElementById(container).appendChild(block_to_insert)
	}

	$(document).ready(function () {
		let hasEvent = false
		let xWindowSize = window.matchMedia('(max-width: 1170px)')
		var mainMenuLi = $('#primary-nav > #privary-navigation > li')
		var mainMenuLiA = mainMenuLi.children('a')

		behaviorMenu()
		xWindowSize.addListener(behaviorMenu)

		//Main Nav Dropdown
		function behaviorMenu() {
			if (xWindowSize.matches) {
				hasEvent = false
				mainMenuLi.unbind()
				mainMenuLi.click(function (e) {
					mainMenuLi.removeClass('active')
					$(this).addClass('active')
					//$('ul.submenu').css('display', 'none');
					if ($(this).children('ul').length > 0) {
						$('ul.submenu', this).css('display', 'block')
					}
				})
				mainMenuLiA.click(function (e) {
					if ($(this).siblings('ul').length > 0) {
						e.preventDefault()
					}
				})
			} else {
				if (!hasEvent) {
					hasEvent = true
					mainMenuLiA.unbind()
					mainMenuLi.hover(
						function () {
							$(this).addClass('hover')
							$('ul.submenu', this).fadeIn(200)
						},
						function () {
							$(this).removeClass('hover')
							$('ul.submenu', this).fadeOut(200)
						},
					)
				}
			}
		}

		$('#menu-btn, .close-menu ').on('click', function () {
			$('.header-menu').toggleClass('active')
		})

		setTimeout(() => {
			$('#start-content').css('opacity', 1)
		}, 0.1)

		if (document.getElementById('map-category')) {
			addAdaMapLink('buttonAda', 'View list of ATTRACTIONS & ENTERTAINMENT')
		}

		$('.info__terms-conditions').on('click', function (e) {
			e.preventDefault()
			let elTerms = $(this).attr('href')
			$(elTerms).toggleClass('info__copy-terms--open')
		})

		// $('#accommodations li.even').addClass('animate-fade right')
		// $('#accommodations li.odd').addClass('animate-fade left')

		// $('.list .container:odd').addClass('animate-fade right')
		// $('.list .container:even').addClass('animate-fade left')

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow()
			behaviorMenu()
		})
		resizeWindow()

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown()
		})

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true]
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val())
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val())
			if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
				DATE_STYLE[1] = 'highlight-top'
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight'
			} else {
				DATE_STYLE[1] = ''
			}
			return DATE_STYLE
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format') ? $('#CheckIn').data('format') : 'd M yy'
		$('#CheckIn').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate')
				let newDate = new Date(getDate.getTime())
				newDate.setDate(newDate.getDate() + 3)
				$('#CheckOut').datepicker('setDate', newDate)
				$('#CheckOut').datepicker('option', 'minDate', selectedDate)
			},
		})
		$('#CheckOut').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			},
		})

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT2 = $('#CheckIn2').data('format') !== undefined && $('#CheckIn2').data('format') ? $('#CheckIn2').data('format') : 'd M yy'
		$('#CheckIn2').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			dateFormat: DATE_FORMAT2,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate')
				let newDate = new Date(getDate.getTime())
				newDate.setDate(newDate.getDate() + 3)
				$('#CheckOut2').datepicker('setDate', newDate)
				$('#CheckOut2').datepicker('option', 'minDate', selectedDate)
			},
		})
		$('#CheckOut2').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: DATE_FORMAT2,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			},
		})

		$('.toggleBooking').on('click', function () {
			$(window).scrollTop(0)
			$('.container-booking, .option-booking .btn').toggleClass('active')
			$('.option-booking .btn').toggleClass('active')
		})

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
	})

	$('.form-entry.rooms, .form-entry.guests, .form-entry.promo').wrapAll("<div class='selectBooking'></div>")

	$('.read-more-blog').click(function () {
		if ($(this).prev('.full-content').is(':hidden')) {
			$(this).prev('.full-content').slideDown()
			$(this).text('View Less')
		} else {
			$(this).prev('.full-content').slideUp()
			$(this).text('View More')
		}
	})

	

	var videoUrl
	$('.open-video2').click(function (event) {
		event.preventDefault()
		videoUrl = $(this).attr('data-video')
	})
	$('.open-video2').fancybox({
		afterShow: function () {
			$('#lightbox-video').attr('src', videoUrl)
			$('#lightbox-video')[0].play()
		},
		overlayShow: true,
		centerOnScroll: true,
		speedIn: 100,
		speedOut: 50,
		allowfullscreen: true,
		width: '100%',
		height: '100%',
		autosize: false,
	})

	$('.fancybox-pdf').fancybox({
		type: 'iframe',
	})

	$('[data-menus]').fancybox({
		slideClass: "fancy-menus",
		btnTpl:{
			smallBtn : '<div data-fancybox-close class="fancybox-close-small modal-close"></div>'
		},
		touch: {
			vertical: false,
			momentum: true // Continue movement after releasing mouse/touch when panning
		}
	})

	$('.virtual-tour_link').fancybox({
		type: 'iframe',
		touch: false,
		width: '100%',
		height: '100%',
		autosize: false,
		padding: 0,
		margin: 50,
		fitToView : false,
		helpers: {
			overlay: {
				locked: false
			}
		},
	})
})()

// * searchParams
// *
// * search params to url
const searchParams = () => {
	if (window.location.search) {

		const URL = window.location.search.slice(1)
		let paramsURL = URL.split('&')

		paramsURL.forEach((param) => {
			let value = param.split('=')[0]
			let key = param.split('=')[1]

			switch (value) {
				case 'quad': // option quad
					scrollQuad(key)
					break
				case 'clic': // option clic in element
					clicElement(key)
					break
				default:
			}
		})
	}
}

const scrollQuad = (selectorElement) => {
	
	if (selectorElement === null || selectorElement === '') return

	let target = document.querySelector(`#${selectorElement}`)

	console.log({selectorElement, target});

	if (target === null) {
		target = document.querySelector(`.${selectorElement}`)
	}

	if (target === null) {
		target = document.querySelector(`[data-tb-quad="${selectorElement}"]`)
	}

	if (target === null) {
		console.error(`ERROR: there is no element with the class, id or data attribute "${selectorElement}"`)
		return
	}

	setTimeout(() => {
		$('html, body').animate({ scrollTop: $(target).offset().top - 500 }, 800)
	}, 600)
}

const clicElement = (selectorElement) => {

	if (selectorElement === null || selectorElement === '') return

	let nodeElement = document.querySelector(`a[href="#${selectorElement}"]`)
	
	if (nodeElement === null) {
		console.error(`ERROR: it is not possible to found the element`)
		return
	}

	setTimeout(() => {
		window.addEventListener('load', () => {
			nodeElement.click()
		})

		scrollQuad(selectorElement)
	}, 200)
}

const onValidParam = (param) => {
	const URL = window.location.search.slice(1)

	if (URL.indexOf(param) === 0) return true
	return false
}

const onScrollAuto = (sourceSelector) => {
	let htmlQuad = sourceSelector.closest('[data-tb-quad]')
	let idQuad = htmlQuad.getAttribute('id') === null ? htmlQuad.dataset.tbQuad : htmlQuad.getAttribute('id')

	scrollQuad(idQuad)
}

searchParams()

